include ../../../common/primary/icon/icon.mixin.pug

.fp-announcement(data-test='announcement' :class='announcementClass()')
  .fp-announcement--text
    span.fp-text(data-test='message') {{ t(announcementUi.messageKey, announcementUi.messageArguments) }}
    a.fp-link(v-if='announcementUi.routeLink && announcementUi.linkKey' @click='goTo' data-test='link') {{ t(announcementUi.linkKey) }}
    router-link.fp-link(v-if='announcementUi.routeLocation && announcementUi.linkKey' :to='announcementUi.routeLocation' data-test='router-link') {{ t(announcementUi.linkKey, announcementUi.messageArguments) }}
  .fp-announcement--close(v-if='announcementUi.showCloseAction' data-test='close' @click='close')
    +fp-icon('close', {size: '12'})
